import React from "react";
import clsx from "clsx";
import { makeStyles, Theme } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import style from "./index.module.scss";

type Anchor = "top" | "left" | "bottom" | "right";

interface ISwipeableProps {
  from: Anchor;
  handlingStore: any;
  state: boolean;
  children: React.ReactNode;
  title?: string;
  calendar: boolean;
  borderRadius?: string;
  headerBottom: boolean;
  headerHeight?: string | number;
  handleBack?: any;
  withBack?: boolean;
  maxHeight?: string;
  image?: string;
}

Swipeable.defaultProps = {
  from: "right",
  state: false,
  calendar: false,
  headerBottom: true,
  withBack: false,
  maxHeight: "100%",
  borderRadius: "8px 8px 0 0",
};

export default function Swipeable(props: ISwipeableProps) {
  const useStyles = makeStyles((theme: Theme) => ({
    list: {
      width: "100vw",
    },
    fullList: {
      width: "auto",
      minHeight: "100px",
      maxHeight: props?.maxHeight,
    },
  }));

  const classes = useStyles();

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }
      props.handlingStore(open);
    };

  const headerPropsCalendar = () => {
    if (props.calendar) {
      return style.header_buttom_aktif;
    } else if (props?.title === "Input Nomor Surat PKS") {
      return style.header_pks;
    } else {
      return style.header_buttom;
    }
  };
  return (
    <React.Fragment>
      <SwipeableDrawer
        id="click-select"
        style={{ zIndex: 700 }}
        anchor={props.from}
        open={props.state}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        disableSwipeToOpen={true}
        PaperProps={{
          style:
            props.from === "bottom"
              ? {
                // borderTopLeftRadius: 8,
                // borderTopRightRadius: 8,
                borderRadius: props.borderRadius,
              }
              : {
                borderRadius: props.borderRadius,
              },
        }}
      >
        <div
          className={clsx(classes.list, {
            [classes.fullList]: props.from === "top" || props.from === "bottom",
          })}
          role="presentation"
        >
          {props.from === "bottom" ? (
            <>
              {props.headerBottom ? (
                <div>
                  <div
                    className={headerPropsCalendar()}
                    style={{
                      height: props.headerHeight,
                    }}
                  >
                    <div className={style.wrapper}>
                      <img
                        src={`${process.env.CDN_URL}/images/main/mobile/swipe-icon.webp`}
                        alt="swipe-icon"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                      }}
                    >
                      {props.withBack === true && (
                        <div
                          style={{
                            marginLeft: "15px",
                            marginTop: "10px",
                          }}
                        >
                          <img
                            src={`${process.env.CDN_URL}/images/main/mobile/back-icon2.webp`}
                            alt="back"
                            width={24}
                            height={24}
                            onClick={props.handleBack}
                          />
                        </div>
                      )}
                      {(props.calendar || props.image || props.title) &&
                        <div
                          className={
                            props.calendar ? style.title_calender : style.title
                          }
                        >
                          {props.image && (
                            <img src={props.image} style={{ height: "20px" }} />
                          )}
                          {props.title}
                        </div>
                      }
                    </div>
                    {(!props.calendar && (props.image || props.title)) && (
                      <hr
                        style={
                          props?.title === "Input Nomor Surat PKS"
                            ? { margin: 0 }
                            : {}
                        }
                        className={style.border_line}
                      />
                    )}
                  </div>
                  {props.children}
                </div>
              ) : (
                <div>
                  <div>{props.children}</div>
                </div>
              )}
            </>
          ) : (
            <div>
              <div>{props.children}</div>
            </div>
          )}
        </div>
      </SwipeableDrawer>
    </React.Fragment>
  );
}
